import React from 'react';
import ReactDOM from 'react-dom';
import util from '../util/util';
import api from '../api/api';


import HeaderComp from './header';
import FooterComp from './footer';

export default class Layout extends React.Component {
    constructor(props){
        super(props);
		this.state = {
			canShowMenu: false
		}
    }
	
	showHideMenu(){
		if(!this.state.canShowMenu){
			return false;
		} else {
			let account = ReactDOM.findDOMNode(this.refs.accountMenuBtn);
			return (
				<div className="loadTip_container accountMenu" onClick="event.cancelBubble = true" id="Load0" style={{width: 250}}>
					<div className="loadTip_header">Account Information</div>
					<div className="loadTip_body">
						<div className="col-12 clearfix accountCategories" style={{padding:0}}>
							<ul className="categoryList" style={{margin:0, border:'none'}}>
								<a href="/myAccount/">
									<li className="dataLists clearfix">
										My Account
									</li>
								</a>
								<a href="/logout.cfm">
									<li className="dataLists clearfix">
										Logout
									</li>
								</a>
							</ul>
						</div>
					</div>
					<img src="/images/icons/loadTip_arrow.png" style={{right: 20, left: 'auto', marginLeft: 'auto', marginRight: -16}} />
				</div>
			)
		}
	}
	
	render() {
		let info = this.props.children;
		return (
			<div style={{height: '100%'}}>
				<HeaderComp>
					{info}
				</HeaderComp>
				<FooterComp />
			</div>
		)
	}
}


/** WEBPACK FOOTER **
 ** ./app/reusable/layout.js
 **/